module.exports = __webpack_public_path__ + "img/profit.1fb59a0d.png";